import React, { useCallback, useEffect, useState } from "react";
import privateAxios from "../../utils/axiosPrivate";
import PropTypes from "prop-types";
import Modalstyle from "./modal.module.scss";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";
import {
  buttonName,
  checklist,
  checkListTab,
  SelectanEmail
} from "../../locales/en";
import {
  getSendQstnEmailUrl,
  getSendEmailListUrl
} from "../../utils/constants/apiEndPoints";
import CommonModal from "./CommonModal";
import ErrorBoundary from "../error-boundary";
import ModalFallback from "../error-boundary/fallback/ModalFallback";

const QuestionEmailSendModel = ({
  isOpen,
  toggle,
  questionIds,
  userId,
  refreshData,
  setLoading
}) => {
  const initialValues = {
    email: ""
  };
  const initialErrors = {
    email: ""
  };
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState(initialErrors);

  const [beneficial, setBeneficial] = useState(false);
  const [adminEmail, setAdminEmail] = useState([]);

  const getAllAdminEmail = useCallback(async () => {
    try {
      const response = await privateAxios.get(getSendEmailListUrl);
      const users = response?.data?.data || [];
      const emails = users.map((user) => user.primaryEmail).filter(Boolean);
      setAdminEmail(emails);
    } catch {
      // cache handle here
    }
  }, [adminEmail, privateAxios]);

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      let isValid = true;
      if (!values.email) {
        isValid = false;
        showToast(checklist.errors.emailSelect, showToastType.error);
      }

      if (isValid) {
        try {
          setLoading(true);
          const sendMailTemplate = {
            userAccountId: userId,
            questionIds: questionIds,
            status: "Sent",
            senderEmail: values.email,
            beneficial: beneficial
          };

          const response = await privateAxios.post(
            getSendQstnEmailUrl,
            sendMailTemplate
          );
          showToast(response.data.message, showToastType.success);
          setValues({ email: "" });
          setErrors({ email: "" });
          toggle();
          refreshData();
        } catch (error) {
          showToast(error?.response?.data?.message, showToastType.error);
        } finally {
          setBeneficial(false);
          setLoading(false);
        }
      }
    },
    [
      questionIds,
      userId,
      privateAxios,
      beneficial,
      values,
      setLoading,
      refreshData,
      toggle
    ]
  );

  const handleInputChange = (field, value) => {
    setValues({
      ...values,
      [field]: value
    });
    setErrors({
      ...errors,
      [field]: ""
    });
  };

  useEffect(() => {
    getAllAdminEmail();
  }, []);

  const footerButtons = [
    {
      label: buttonName.sendEmail,
      className: "btn btn-primary",
      onClick: handleSubmit,
      disabled: !values.email
    },
    {
      label: buttonName.close,
      className: "btn btn-secondary",
      onClick: toggle
    }
  ];

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={checkListTab?.selectQuestion?.emailSendModal?.title}
      modalClassName=""
      bodyClassName=""
      footerButtons={footerButtons}
    >
      <ErrorBoundary fallback={<ModalFallback />}>
        <div className="row col-md-12 mb-3">
          <div className={Modalstyle.modalInputwrap}>
            <div className={Modalstyle.formInput}>
              <select
                id="email"
                value={values.email}
                onChange={(e) => handleInputChange("email", e.target.value)}
              >
                <option value="">{SelectanEmail}</option>
                {adminEmail.map((email) => (
                  <option key={email} value={email}>
                    {email}
                  </option>
                ))}
              </select>
              {errors.email && (
                <div className="text-danger small">{errors.email}</div>
              )}
            </div>
          </div>
          <div className="col-md-12 mb-3">
            <input
              type="checkbox"
              className="mt-1"
              onChange={(e) => setBeneficial(e.target.checked)}
            />
            <span className="small">
              {checkListTab?.selectQuestion.emailSendModal.paraGph}
            </span>
          </div>
        </div>
      </ErrorBoundary>
    </CommonModal>
  );
};

QuestionEmailSendModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  questionIds: PropTypes.any,
  userId: PropTypes.any,
  refreshData: PropTypes.any,
  refreshLoading: PropTypes.any,
  setLoading: PropTypes.func
};

export default QuestionEmailSendModel;
